import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { DeviceDto, RegisterDeviceBody } from '../models/core/device.models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DeviceService {
	private readonly baseUrl = `${environment.api_server}/api/v2/devices`;

	constructor(private readonly http: HttpClient, private readonly api: ApiService) {}

	private async authHeaders(): Promise<HttpHeaders> {
		return this.api.getAuthHeaders();
	}

	async getDevices() {
		const url = `${this.baseUrl}/`;
		const headers = await this.authHeaders();
		return this.http.get<DeviceDto[]>(url, { headers });
	}

	async registerDevice(body: RegisterDeviceBody) {
		const url = `${this.baseUrl}/register`;
		const headers = await this.authHeaders();
		return this.http
		  .post<{ device: DeviceDto }>(url, body, { headers })
		  .pipe(map(res => res.device));
	  }

	async updateToken(installation_id: string, push_token: string) {
		const url = `${this.baseUrl}/token`;
		const headers = await this.authHeaders();
		return this.http.put<void>(url, { installation_id, push_token }, { headers });
	}

	async heartbeat(installation_id: string, meta?: { app_version?: string; app_build?: number; locale?: string }) {
		const url = `${this.baseUrl}/heartbeat`;
		const headers = await this.authHeaders();
		return this.http.post<void>(url, { installation_id, ...meta }, { headers });
	}

	async deactivate(serverDeviceId: string) {
		const url = `${this.baseUrl}/${serverDeviceId}/deactivate`;
		const headers = await this.authHeaders();
		return this.http.post<void>(url, {}, { headers });
	}
}


